var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 1.875C3.33333 0.837891 2.58854 0 1.66667 0C0.744792 0 0 0.837891 0 1.875V7.5V22.5C0 24.5684 1.49479 26.25 3.33333 26.25H13.3333V22.5H3.33333V9.375H13.3333V5.625H3.33333V1.875ZM15 11.25C15 12.2871 15.7448 13.125 16.6667 13.125H28.3333C29.2552 13.125 30 12.2871 30 11.25V3.75C30 2.71289 29.2552 1.875 28.3333 1.875H23.1927C22.75 1.875 22.3281 1.67578 22.0156 1.32422L21.3229 0.550781C21.0104 0.199219 20.5885 0 20.1458 0H16.6667C15.7448 0 15 0.837891 15 1.875V11.25ZM15 28.125C15 29.1621 15.7448 30 16.6667 30H28.3333C29.2552 30 30 29.1621 30 28.125V20.625C30 19.5879 29.2552 18.75 28.3333 18.75H23.1927C22.75 18.75 22.3281 18.5508 22.0156 18.1992L21.3229 17.4199C21.0104 17.0684 20.5885 16.8691 20.1458 16.8691H16.6667C15.7448 16.8691 15 17.707 15 18.7441V28.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyStructure);
export default __webpack_public_path__ + "static/media/company-structure.5f557ce95430cf576fb727bcac87d616.svg";
export { ForwardRef as ReactComponent };